<div class="global-announcement-modal">
  <h2 mat-dialog-title class="sdf-text-600 sdf-font-bold">
    {{ 'GlobalAnnouncement.Title' | translate }}
  </h2>

  <mat-dialog-content class="sdf-text-body-medium">
    <div class="announcement-content">
      <p>{{ 'GlobalAnnouncement.Message' | translate }}</p>

      <div class="announcement-details">
        <ul>
          <li>
            {{ 'GlobalAnnouncement.Point1' | translate }}
            <span class="sdf-badge sdf-badge-filled-yellow license-requirement">
              <fa-icon [icon]="faKey"></fa-icon>
              {{ 'GlobalAnnouncement.LicenseRequired' | translate }}
            </span>
          </li>
          <li>{{ 'GlobalAnnouncement.Point2' | translate }}</li>
          <li>{{ 'GlobalAnnouncement.Point3' | translate }}</li>
        </ul>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      class="sdf-btn sdf-btn--lg sdf-btn--primary"
      (click)="onConfirm()">
      <fa-icon [icon]="faThumbsUp"></fa-icon>
      {{ 'GlobalAnnouncement.ConfirmButton' | translate }}
    </button>
  </mat-dialog-actions>
</div>


